import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=fc2bf950&scoped=true"
import script from "./Icon.js?vue&type=script&lang=js&external"
export * from "./Icon.js?vue&type=script&lang=js&external"
import style0 from "./Icon.scss?vue&type=style&index=0&id=fc2bf950&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2bf950",
  null
  
)

export default component.exports